import { getConsent } from "./consent";

export const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "1205453832141580";
export const PRODUCT_ID = "MMCS-12HRN8-QRD0";
export const PRODUCT_NAME = "Midea PortaSplit 12 000 BTU";
const FBCLID = new URLSearchParams(window.location.search).get("fbclid");

const cookie = (name) => document.cookie.split("; ").find((c) => c.startsWith(`${name}=`))?.split("=")[1] || null;

export const checkoutMeta = () => {
  if (!allowed()) return { meta_consent: false };
  const fbc = cookie("_fbc") || (FBCLID ? `fb.1.${Date.now()}.${FBCLID}` : null);
  return { meta_consent: true, fbp: cookie("_fbp"), fbc };
};
let loaded = false;

const allowed = () => getConsent()?.ads === true && !window.location.pathname.startsWith("/admin");

export const loadPixel = () => {
  if (loaded || !allowed() || !PIXEL_ID) return loaded;
  const fbq = function () {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
  };
  if (!window.fbq) {
    window.fbq = window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://connect.facebook.net/en_US/fbevents.js";
    s.dataset.metaPixel = "true";
    document.head.appendChild(s);
    window.fbq("init", PIXEL_ID);
  } else {
    window.fbq("consent", "grant");
  }
  loaded = true;
  return true;
};

export const track = (name, params, eventID) => {
  if (!allowed() || !loadPixel()) return false;
  if (eventID) window.fbq("track", name, params || {}, { eventID });
  else window.fbq("track", name, params || {});
  return true;
};

export const revokePixel = () => {
  if (window.fbq) window.fbq("consent", "revoke");
  loaded = false;
  document.cookie.split(";").forEach((c) => {
    const name = c.split("=")[0].trim();
    if (name === "_fbp" || name === "_fbc") document.cookie = `${name}=; Max-Age=0; path=/`;
  });
};

const FIRED = "climnova_fb_purchases";
export const purchaseOnce = (orderId, value, numItems) => {
  const fired = JSON.parse(localStorage.getItem(FIRED) || "[]");
  if (fired.includes(orderId)) return false;
  const ok = track("Purchase", { value, currency: "EUR", content_ids: [PRODUCT_ID], content_type: "product", num_items: numItems }, orderId);
  if (ok) localStorage.setItem(FIRED, JSON.stringify([...fired, orderId]));
  return ok;
};
